module.exports = __webpack_public_path__ + "img/shennongcaotangbowuguan.18690747.png";